const urls = {
  fetchLoadTypes: () => {
    return `/vehicle/loadType`;
  },
  fetchConsignmentDetails: (payload: number) => {
    return `/admin/consignment/get?cId=${payload}`;
  },
  fetchLanes: (payload: number) => {
    return `/lanes/getLanes?oId=${localStorage.getItem('opid_trucking')}&vid=${payload}`;
  },

  updateConsignment: () => {
    return `/admin/consignment/update`;
  },
};

export default urls;
